import { createEmptyCanvas } from "@/components/canvas/helpers/canvasHelpers";
import { extractDynamicTextFromCanvasData, removeMustache } from "@/components/canvas/utils/canvasUtils";
import { TemplateResponse, Template, StockTemplateResponse } from "@/lib/types";
import { DynamicTemplateDataSourceResponseItem } from "@/pages/content/contentTypes";

export const convertToTemplate = (templateResponse: TemplateResponse | StockTemplateResponse): Template => {
  let rawCanvasData = templateResponse.canvas_data;
  if (rawCanvasData === "undefined" || !rawCanvasData) {
    rawCanvasData = JSON.stringify(createEmptyCanvas(1920, 1080));
  }
  if (rawCanvasData) {
    const parsedCanvasData = JSON.parse(rawCanvasData);
    if (!parsedCanvasData["objects"] || !parsedCanvasData["version"]) {
      rawCanvasData = JSON.stringify(createEmptyCanvas(1920, 1080));
    }
  }

  return {
    id: templateResponse.id,
    name: templateResponse.name,
    canvas_data: JSON.parse(rawCanvasData),
    viewport_size: templateResponse.viewport_size,
    created_at: templateResponse.created_at,
    updated_at: templateResponse.updated_at,
    firmGuid: "firmGuid" in templateResponse ? templateResponse.firmGuid : undefined,
    categoryName: "category_name" in templateResponse ? templateResponse.category_name : undefined,
  };
};

export const bindDataSourceToTemplate = (template: Template, dataSource: DynamicTemplateDataSourceResponseItem[]) => {
  const newTemplate: Template = JSON.parse(JSON.stringify(template));
  const dynamicTexts = extractDynamicTextFromCanvasData(template.canvas_data);

  for (const dynamicText of dynamicTexts) {
    for (const dynamicValue of dynamicText.dynamicValues) {
      const property = removeMustache(dynamicValue);
      const propertyValue = dataSource.find((item) => item.key === property)?.value;
      if (propertyValue) {
        newTemplate.canvas_data.objects[dynamicText.indexInCanvasData].text = newTemplate.canvas_data.objects[
          dynamicText.indexInCanvasData
        ].text.replaceAll(dynamicValue, propertyValue);
      }
    }
  }

  return newTemplate;
};
